module.exports = __webpack_public_path__ + "static/bg_top-c2766bb8eee62d40f52e552967233cb3.jpg";